import request from '../../utils/requests'
/** * Tag: BargainAttend */
const baseUrl ="/api/BargainAttend";

/** * 匿名：帮砍名单 * @param {*} body * { *    BargainSponsorId Desc:发起砍价ID Required:false *    Start Desc:开始行数 从0开始 Required:false *    Length Desc:页面大小 Required:false *    End Desc:结束行数 Required:false * } */async function _pagingForAnonymous(body) {  return request(baseUrl+'/pagingForAnonymous',{    method: 'POST',    body: body,  });
}

/** * 匿名：帮砍 * @param {*} body * { *    BargainSponsorId Desc:帮砍的砍价发起ID Required:false *    OpenId Desc:OpenId Required:false * } */async function _addForAnonymous(body) {  return request(baseUrl+'/addForAnonymous',{    method: 'POST',    body: body,  });
}

/** * 帮砍名单 * @param {*} body * { *    BargainSponsorId Desc:发起砍价ID Required:false *    Start Desc:开始行数 从0开始 Required:false *    Length Desc:页面大小 Required:false *    End Desc:结束行数 Required:false * } */async function _paging(body) {  return request(baseUrl+'/paging',{    method: 'POST',    body: body,  });
}

/** * 帮砍 * @param {*} body * { *    BargainSponsorId Desc:帮砍的砍价发起ID Required:false *    OpenId Desc:OpenId Required:false * } */async function _add(body) {  return request(baseUrl+'/add',{    method: 'POST',    body: body,  });
}

export default{  _pagingForAnonymous,  _addForAnonymous,  _paging,  _add}



// WEBPACK FOOTER //
// ./src/services/bargainAttend.js